// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/activity.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ListActivityRequest, ListActivityResponse, ListEntityActivityRequest, ListEntityActivityResponse } from "./activity_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.ActivityService
 */
export const ActivityService = {
  typeName: "omnios.v1.ActivityService",
  methods: {
    /**
     * @generated from rpc omnios.v1.ActivityService.ListActivity
     */
    listActivity: {
      name: "ListActivity",
      I: ListActivityRequest,
      O: ListActivityResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ActivityService.ListEntityActivity
     */
    listEntityActivity: {
      name: "ListEntityActivity",
      I: ListEntityActivityRequest,
      O: ListEntityActivityResponse,
      kind: MethodKind.Unary,
    },
  }
};

